import { z } from 'zod';
import { uuidSchema } from './common.js';
export const searchSuggestionSchema = z.object({
    kind: z.enum(['recipe', 'tag', 'category', 'ingredient', 'collection']),
    id: uuidSchema.nullable(),
    label: z.string(),
    hint: z.string().nullable(),
});
export const searchSuggestQuerySchema = z.object({
    q: z.string().trim().min(1).max(100),
    limit: z.coerce.number().int().min(1).max(20).default(8),
});
export const searchFacetsSchema = z.object({
    tags: z.array(z.object({ id: uuidSchema, name: z.string(), count: z.number().int() })),
    categories: z.array(z.object({ id: uuidSchema, name: z.string(), count: z.number().int() })),
    cuisines: z.array(z.object({ value: z.string(), count: z.number().int() })),
    mealTypes: z.array(z.object({ value: z.string(), count: z.number().int() })),
});
//# sourceMappingURL=search.js.map